import styled, { css } from "styled-components";

const UserDetailsStyles = css`
    .signup-card-title {
        font-size: 48px;
        margin-top: 28px;
    }

    .signup-card-subtitle {
        font-size: 24px;
        margin-top: 24px;
        line-height: 36px;
    }

    .signup-card-description {
        font-size: 16px;
        margin-top: 16px;
        line-height: 28px;
        color: #585757;
    }

    .input-card {
        border-radius: 14px;
        padding: 14px 16px 12px 16px;
        width: 100% - 16px;
        border: 1px solid #D9DAE9;
        font-family: Inter, system-ui, -apple-system, sans-serif;
        margin-top: 16px;
    }

    .input-title {
        display: block;
        font-size: 13px;
        font-weight: 500;
        color: #9aa0a6;
        margin-bottom: 4px;
    }

    .input-field {
        width: 100%;
        border: none;
        outline: none;
        font-size: 16px;
        font-weight: 500;
        color: #111111;
        background: transparent;
        padding: 0;
    }

    .input-field-phcode {
        width: 20%;
        border: none;
        outline: none;
        font-size: 16px;
        font-weight: 500;
        color: #111111;
        background: transparent;
        padding: 0;
    }

    .input-field-phno {
        width: 70%;
        border: none;
        outline: none;
        font-size: 16px;
        font-weight: 500;
        color: #111111;
        background: transparent;
        padding: 0;
    }

    .number-holder {
        margin-right: 6px;
        font-size: 16px;
        margin-top: -2px;
        font-weight: 500;
        color: #111111
    }

    .error-message {
        text-align: center;
        margin-top: 16px;
        color: #a70202;
        font-size: 16px;
        font-weight: 500;
    }

    .signup-card-qr-code-holder {
        margin-top: 24px;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 18px;
        font-size: 16px;
        letter-spacing: 0.6px;
    }

    .signup-card-link {
        font-size: 16px;
        font-weight: 500;
        color: #2b2a2a;
        display: flex;
        align-items: center;
        gap: 6px;
        border: 1px solid #474646;
        border-radius: 12px;
        padding: 8px 16px;
        width: 180px;
        justify-content: center;
        cursor: pointer;
        &:hover {
            background-color: #ebeaea;
            border-color: #ebeaea;
        }
    }

    @media (max-width: 640px) {
        .signup-card-title {
            font-size: 24px;
            margin-top: 18px;
        }

        .signup-card-subtitle {
            font-size: 16px;
            margin-top: 14px;
            line-height: 22px;
        }

        .signup-card-description {
            font-size: 12px;
            margin-top: 14px;
            line-height: 15px;
        }

        .input-card {
            border-radius: 14px;
            padding: 8px 16px;
            width: 100% - 8px;
            margin-top: 12px;
        }

        .input-title {
            font-size: 10px;
        }

        .number-holder {
            margin-right: 2px;
            font-size: 12px;
            margin-top: 1px;
            font-weight: 400;
        }

        .input-field {
            font-size: 12px;
            font-weight: 400;
            padding: 0;
        }

        .input-field-phcode {
            font-size: 12px;
            font-weight: 400;
            padding: 0;
        }

        .input-field-phno {
            font-size: 12px;
            font-weight: 400;
            padding: 0;
        }

        .error-message {
            margin-top: 13px;
            font-size: 14px;
        }
    }
`;


export const TagDropdownSC = styled.div`
    width: 100% - 16px;
    position: relative;
    font: Inter, system-ui, sans-serif;
    margin-top: 16px;

    .field-label {
        font-size: 14px;
        font-weight: 500;
        color: #667085;
        margin-bottom: 6px;
        margin-left: 4px;
        display: block
    }

    .select-box {
        background: #ffffff;
        border: 1px solid #DDDAE6;
        border-radius: 12px;
        padding: 16px;
        font-size: 15px;
        color: #101828;
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        box-shadow: 0 1px 2px rgba(16,24,40,0.04);
    }

    .chevron {
        font-size: 14px;
        color: #667085
    }

    .dropdown {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        margin-top: 6px;
        margin-bottom: 80px;
        background: #ffffff;
        padding: 6px;
        padding-bottom: 20px;
        box-shadow: 0 8px 20px rgba(16,24,40,0.10);
        z-index: 20
    }

    .option-entry {
        padding: 10px 12px;
        font-size: 14px;
        border-radius: 8px;
        cursor: pointer;
        color: #344054
    }

    .option-active {
        background: #E9F8EC;
        color: #2E9F3E
    }

    .dropdown-overlay {
    display: none;
}

@media (max-width: 640px) {
    .dropdown-overlay {
        display: block;
        position: fixed;
        inset: 0;
        background: rgba(16, 24, 40, 0.4);
        z-index: 999;
    }

    .mobile-sheet {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        max-height: 85vh;
        background: #ffffff;
        border-radius: 16px 16px 0 0;
        padding: 12px 16px 24px;
        overflow-y: auto;
        animation: slideUp 220ms ease-out;
    }

    .sheet-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        font-weight: 500;
        padding-bottom: 12px;
        border-bottom: 1px solid #EAECF0;
        margin-bottom: 8px;
    }

    .sheet-header button {
        background: none;
        border: none;
        font-size: 18px;
        cursor: pointer;
    }

    @keyframes slideUp {
        from {
            transform: translateY(100%);
        }
        to {
            transform: translateY(0);
        }
    }
}
    @media (max-width: 640px) {
        width: 100% - 8px;
        margin-top: 8px;

        .field-label {
            font-size: 12px;
            font-weight: 400;
            margin-bottom: 4px;
            margin-left: 6px;
        }

        .select-box {
            border-radius: 12px;
            padding: 8px 16px;
            font-size: 12px;
        }

        .dropdown {
            margin-top: 6px;
            margin-bottom: 40px;
            padding: 6px;
            padding-bottom: 20px;
        }

        .option-entry {
            padding: 8px 10px;
            font-size: 12px;
        }
    }
`;

export default UserDetailsStyles;